import React from 'react';
import App from '../App/App';
import Banner from './Banner';
import Product from './Product';
import Solution from './Solution';
import ServiceLayer from './ServiceLayer';
import {Layers} from '../../components';
import {banner, product, solution, service} from './config';

export default function Home() {
  if (!global.isServer) {
    document.title = '云恋科技-物流控制塔、TMS、网络货运平台解决方案、综合物流解决方案！';
  }
  return (
    <App className='Home'>
      <Banner data={banner} />
      <Product data={product} md={4}/>
      <Solution data={solution} md={3}/>
      <Layers title='综合服务' data={service} grey>
        <ServiceLayer />
      </Layers>
    </App>
  );
};



// WEBPACK FOOTER //
// ./src/routes/Home/Home.js